import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import InternalService from '../../services/internal-api';
import Loading from '../loading';
import './offline.css';

export default class Offline extends Component {
  stampsData = new InternalService();

  state = {
    loading: false,
    sent: false,
    offline: (this.stampsData._clientBase === 'http://localhost:3000/')
  };

  componentDidMount() {
    document.title = `Seals of Ancient Rus' - offline version`;
    ;
  }

  render() {
    const { loading, sent, offline } = this.state;
    if (loading) return <Loading />;

    if (sent) {
      return (
        <div className="offline_thankyou">
          <h3>🚀 We received your request and will get back to you soon.</h3>
        </div>
      );
    }

    if (offline) {
      return (
        <div className="offline_thankyou">
          <h3>✈️📵 You are running an offline version of the database: v. 1.0 (October 2025).</h3>
        </div>
      );
    }

    return (
      <Formik
        initialValues={{
          name: '',
          organization: '',
          purpose: '',
          email: '',
          agree: false,
        }}
        validate={(values) => {
          const errors = {};
          if (!values.name) errors.name = 'Required';
          if (!values.organization) errors.organization = 'Required';
          if (!values.purpose) errors.purpose = 'Required';
          if (!values.email) {
            errors.email = 'Required';
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = 'Invalid email address';
          }
          if (!values.agree) {
            errors.agree = 'You must confirm before submitting';
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          this.setState({ loading: true });
          setTimeout(() => {
            this.stampsData
              .requestOfflineVersion(
                values.email,
                values.name,
                values.organization,
                values.purpose
              )
              .then(() => this.setState({ loading: false, sent: true }))
              .catch((error) => console.log(error));
            setSubmitting(false);
          }, 400);
        }}
      >
        {({ isSubmitting }) => (
          <Form className="offline_form-container">
            <div className="offline_form-panel">
              <h4 className="offline_form-title">Get your own copy</h4>

              <label className="offline_form-label">Name</label>
              <Field className="offline_form-input" name="name" />
              <ErrorMessage
                className="offline_error-message"
                name="name"
                component="div"
              />

              <label className="offline_form-label">Organization</label>
              <Field
                className="offline_form-textarea"
                name="organization"
                as="textarea"
                rows="2"
              />
              <ErrorMessage
                className="offline_error-message"
                name="organization"
                component="div"
              />

              <label className="offline_form-label">Purpose</label>
              <Field
                className="offline_form-textarea"
                name="purpose"
                as="textarea"
                rows="5"
              />
              <ErrorMessage
                className="offline_error-message"
                name="purpose"
                component="div"
              />

              <label className="offline_form-label">Email</label>
              <Field className="offline_form-input" type="email" name="email" />
              <ErrorMessage
                className="offline_error-message"
                name="email"
                component="div"
              />

              <div className="offline_notice">
                <p>
                  The offline version of <strong>Kievan-Rus.Online</strong> is
                  distributed <strong>free of charge</strong> for research and
                  educational purposes only.  
                  The authors and maintainers accept no responsibility for any
                  use or consequences arising from its installation or content.
                </p>
              </div>

              <div className="offline_agreement">
                <label>
                  <Field type="checkbox" name="agree" />
                  <span>
                    I confirm that I have read and agree to the above terms.
                  </span>
                </label>
                <ErrorMessage
                  className="offline_error-message"
                  name="agree"
                  component="div"
                />
              </div>

              <button
                type="submit"
                className="offline_form-button"
                disabled={isSubmitting}
              >
                Submit
              </button>
            </div>

            <div className="offline_info-panel">
              <section id="kievan-rus-offline" className="kr-offline">
                <div className="kr-intro">
                  <p>
                    <strong>Kievan-Rus.Offline</strong> is the offline
                    distribution of our complete database. It ensures{' '}
                    <strong>
                      long-term preservation and autonomous access
                    </strong>{' '}
                    to the full dataset when the online service may no longer be
                    available.
                  </p>

                  <p>
                    The full database is distributed{' '}
                    <strong>free of charge</strong> as a standalone desktop
                    application. Once installed, the application runs entirely
                    on your local computer and does not require an internet
                    connection.
                  </p>
                </div>

                <section className="kr-request">
                  <h2>How to request a copy</h2>
                  <p>
                    Please complete the request form and tell us{' '}
                    <em>who you are</em> and <em>why you require a copy</em>.
                    After receiving your submission, we will send a personalized
                    download link.
                  </p>
                  <p className="important">
                    <strong>⚠️ Important:</strong> Ensure at least{' '}
                    <strong>2 GB</strong> of free disk space is available to
                    accommodate the database and associated images.
                  </p>
                </section>

                <section
                  className="kr-requirements"
                  aria-labelledby="requirements-title"
                >
                  <h2 id="requirements-title">System requirements</h2>
                  <dl>
                    <dt>Operating system</dt>
                    <dd>macOS 11 (Big Sur) or later / Windows 10 or later</dd>

                    <dt>Processor</dt>
                    <dd>macOS: Apple Silicon (M1, M2, M3, or newer)<br/>
                        Windows: any</dd>

                    <dt>Disk space</dt>
                    <dd>
                      Approximately <strong>1.8 GB</strong> (please keep at least 2 GB free)
                    </dd>
                  </dl>

                  <p>
                    If your computer does not meet these requirements, please
                    indicate your operating system and version in the{' '}
                    <em>Purpose</em> field of the request form. We will
                    investigate the possibility of providing a compatible build
                    for your platform.
                  </p>
                  <p className="important">
                    <strong>⚠️ Image Usage Notice:</strong> All images included in this database are used solely for research and educational purposes.
They are provided for identification rather than for viewing or reproduction.
Copyrights remain with their respective rights holders, as indicated in the referenced publications.
Any distribution or commercial use of these images outside this context is strictly prohibited.
                  </p>
                </section>
              </section>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}
